<template>
	<div class="workflow-disclaimer">
		<p class="body-1">
			<base-icon class="info-icon" icon-name="info" /> <!-- pdf icon -->
			{{ $t('message.workflowDisclaimer') }}
		</p>
	</div>
</template>

<script>
export default {
	name: 'workflowDisclaimer',
};
</script>

<style lang="scss">
.workflow-disclaimer {
	margin-top: 25px;
	margin-bottom: 40px;
	background-color: $color-extra-light-grey;
}
</style>
